import vectorUtils from '@utils/vectorUtils'
import dateUtils from '@utils/DateUtils'
import utils from '@utils/genUUID'
import sizeUtils from '@utils/sizeUtils'
import Vector from './vector'

export default class VectorGeojson extends Vector {
  constructor (obj, index) {
    super(obj)
    Object.assign(this, {
      _listProperties: [],
      _isGeoJson: true,
      _isResult: obj.is_result,
      _createdAt: obj.created_at
        ? dateUtils.convertUTCToLocalDateV2(obj.created_at)
        : undefined,
      _createdBy: obj.created_by,
      _path: `${obj.path}${
        obj.path.includes('?') ? '&' : '?'
      }ver=${utils.getUUID()}`,
      _downloadUrl: obj.path,
      _displayType: obj.style ? obj.style.type : 'line',
      _style: obj.style ? obj.style.paint : undefined,
      _type: obj.type ? obj.type : undefined,
      loading: false,
      _imageId: obj.images ? obj.images.image_id : null,
      _meta: obj.meta ? this.transformMeta(obj.meta) : {},
      _modelId: obj.model_id,
      _ownerId: 86,
      _pathRef: obj.path,
      _imageRef: obj.ref_id,
      _modelName: obj.model_name ? obj.model_name : '',
      _size: obj.size_mb ? this.transformSize(obj.size_mb) : '0 KB',
      _originalSize: obj.size_mb ? obj.size_mb : 0,
      _taskId: obj.task_id,
      _updatedAt: obj.updated_at
        ? dateUtils.convertUTCToLocalDateTime(obj.updated_at)
        : undefined,
      _workspaceId: obj.workspace_id,
      _categories: obj.categories ? obj.categories : [],
      _properties: { listValue: this.getListValue(obj.meta) },
      _isOpenClass: false,
      _isExpand: !!(obj.meta && obj.meta.labels)
    })
  }
  transformSize (size) {
    if (size !== undefined && size !== null && size !== '') {
      return sizeUtils.transfSize(size)
    } else {
      return '0 KB'
    }
  }

  getListValue (meta) {
    if (meta && meta.labels) return meta.labels
    return undefined
  }
  transformMeta (meta) {
    if (meta && !meta.bbox && meta.geometry) {
      meta.bbox = vectorUtils.coordinatesToBBox(
        meta.geometry.features[0].geometry.coordinates
      )
    }
    return meta
  }

  get allowStyle () {
    return this._allowStyle
  }

  get displayType () {
    return this._displayType
  }

  get originalSize () {
    return this._originalSize
  }
  get isGeoJson () {
    return this._isGeoJson
  }
  get style () {
    return this._style
  }
  set style (newValue) {
    this._style = newValue
  }
  get properties () {
    return this._properties
  }
  set properties (newValue) {
    this._properties = newValue
  }
  get type () {
    return this._type
  }
  get isResult () {
    return this._isResult
  }
  get categories () {
    return this._categories
  }
  get modelName () {
    return this._modelName
  }
  get createdAt () {
    return this._createdAt
  }

  get createdBy () {
    return this._createdBy
  }
  get workspaceId () {
    return this._workspaceId
  }
  get downloadUrl () {
    return this._downloadUrl
  }

  get imageId () {
    return this._imageId
  }

  get meta () {
    return this._meta
  }

  get modelId () {
    return this._modelId
  }

  get imageRef () {
    return this._imageRef
  }

  get ownerId () {
    return this._ownerId
  }

  get path () {
    return this._path
  }

  get size () {
    return this._size
  }

  get colorPalette () {
    return this._updatedAt
  }

  get taskId () {
    return this._taskId
  }

  get isOpenClass () {
    return this._isOpenClass
  }

  set isOpenClass (newValue) {
    this._isOpenClass = newValue
  }
  get isExpand () {
    return this._isExpand
  }

  set isExpand (newValue) {
    this._isExpand = newValue
  }

  get listProperties () {
    return this._listProperties
  }

  set listProperties (newValue) {
    this._listProperties = newValue
  }
}



// WEBPACK FOOTER //
// ./src/models/vector/vector-geojson.js